import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex justify-content-start flex-wrap white-space-nowrap" }
const _hoisted_2 = { class: "mr-s5 mt-s3" }
const _hoisted_3 = {
  key: 1,
  class: "text-gradient text-bold"
}
const _hoisted_4 = { class: "mr-s5 mt-s3" }
const _hoisted_5 = {
  key: 1,
  class: "text-gradient text-bold"
}
const _hoisted_6 = { class: "mr-s5 mt-s3" }
const _hoisted_7 = {
  key: 1,
  class: "text-gradient text-bold"
}

import Caption from '@/components/Caption.vue';
import { useVesting } from '@/composables/core/useVesting';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { startDateFormatted, monthsPeriod, totalInPoolFormatted } = useVesting();

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!_unref(startDateFormatted))
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 0,
            class: "mr-2 w-4rem"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(startDateFormatted)), 1)),
      _createVNode(Caption, {
        caption: "Start date",
        tooltip: "The date when your vesting starts."
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!_unref(monthsPeriod))
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 0,
            class: "mr-2 w-4rem"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(monthsPeriod)) + " months ", 1)),
      _createVNode(Caption, {
        caption: "Vesting period",
        tooltip: "Your tokens will be released linearly during the vesting period."
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      (!_unref(totalInPoolFormatted))
        ? (_openBlock(), _createBlock(_component_Skeleton, {
            key: 0,
            class: "mr-2 w-4rem"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(totalInPoolFormatted)), 1)),
      _createVNode(Caption, { caption: "Total number of BLUES tokens" })
    ])
  ]))
}
}

})